import { Button, CircularProgress, Typography } from "@material-ui/core";
import React from "react";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "../../../../../components/Dialog";
import { actorName, DebtorBlockEvent, formatEventTime } from "./debtorBlock";

interface Props {
  open: boolean;
  clientName: string;
  events: DebtorBlockEvent[];
  loading: boolean;
  error: string;
  onClose: () => void;
}

const grid = {
  display: "grid",
  gridTemplateColumns: "96px 150px 190px minmax(0, 1fr)",
  alignItems: "center"
} as React.CSSProperties;

const chipColors = {
  BLOCKED: { background: "#fdecec", color: "#8e1414" },
  UNBLOCKED: { background: "#e3f2fd", color: "#0d47a1" }
};

const BlockHistoryDialog = ({
  open,
  clientName,
  events,
  loading,
  error,
  onClose
}: Props): JSX.Element => (
  <Dialog open={open} fullWidth maxWidth="md" onClose={onClose}>
    <DialogTitle onClose={onClose}>Factoring block history</DialogTitle>
    <DialogContent>
      <Typography style={{ color: "#616161", marginBottom: 12 }}>
        Bulk block and unblock actions for {clientName}, newest first.
      </Typography>
      <Typography
        component="div"
        style={{
          ...grid,
          padding: "8px 0",
          fontSize: 12,
          color: "#1e88e5",
          borderTop: "1px solid #e0e0e0",
          borderBottom: "1px solid #e0e0e0"
        }}
      >
        <div>Action</div>
        <div>By</div>
        <div>When</div>
        <div>Reason</div>
      </Typography>
      {loading && (
        <div style={{ padding: 20, textAlign: "center" }}>
          <CircularProgress size={24} />
        </div>
      )}
      {!loading && error && (
        <Typography color="error" role="alert" style={{ padding: "20px 0" }}>
          {error}
        </Typography>
      )}
      {!loading && !error && events.length === 0 && (
        <Typography component="div" style={{ padding: "20px 0", fontSize: 13, color: "#757575" }}>
          No bulk block or unblock actions yet.
        </Typography>
      )}
      {!loading &&
        !error &&
        events.map((event) => (
          <Typography
            component="div"
            key={event.id}
            style={{ ...grid, padding: "10px 0", fontSize: 13, borderBottom: "1px solid #eeeeee" }}
          >
            <div>
              <span
                style={{
                  ...chipColors[event.action],
                  display: "inline-block",
                  padding: "2px 8px",
                  borderRadius: 10,
                  fontSize: 11,
                  fontWeight: 700
                }}
              >
                {event.action}
              </span>
            </div>
            <div>{actorName(event)}</div>
            <div style={{ color: "#616161" }}>{formatEventTime(event.created)}</div>
            <div style={{ color: event.reason ? "#212121" : "#9e9e9e" }}>
              {event.reason || "No reason given"}
            </div>
          </Typography>
        ))}
    </DialogContent>
    <DialogActions>
      <Button color="primary" onClick={onClose}>
        Close
      </Button>
    </DialogActions>
  </Dialog>
);

export default BlockHistoryDialog;
